export const defaultIconStyles = {
  height: '1rem',
  width: '1rem'
};